import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateWallet } from '../walletServices'
import { WalletPayload } from '../walletTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

// Query keys for invalidation
const QUERY_KEY_WALLET = 'wallet'
const QUERY_KEY_CURRENCIES = 'currencies'
const QUERY_KEY_REQUESTS = 'requests'

export const useUpdateWallet = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: WalletPayload) => {
      return updateWallet(payload)
    },
    onSuccess: () => {
      // Refresh wallet cache
      queryClient.refetchQueries({ queryKey: [QUERY_KEY_WALLET] })

      // Refresh currencies cache
      queryClient.refetchQueries({ queryKey: [QUERY_KEY_CURRENCIES] })
      // UPDATE REQUESTS BECAUSE OF DISPLAY CURRENCY CHANGE
      queryClient.removeQueries({ queryKey: [QUERY_KEY_REQUESTS] })
      // UPDATE TRANSACTIONS BECAUSE OF DISPLAY CURRENCY CHANGE
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.TRANSACTIONS] })
      // UPDATE CASHBACK BECAUSE OF DISPLAY CURRENCY CHANGE
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.CASHBACK_INFO] })
      // UPDATE CURRENCY IN BLOCKCHAIN BECAUSE OF DISPLAY CURRENCY CHANGE
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.CATALOGS_CURRENCIES] })
    },
    onError: () => {},
  })
}
